import { render } from "./DhTextarea.vue?vue&type=template&id=1c530c29"
import script from "./DhTextarea.vue?vue&type=script&lang=ts"
export * from "./DhTextarea.vue?vue&type=script&lang=ts"
script.render = render

export default script